import { EncabezadoPagina } from '@xiltrion/ui/bloques/encabezado-pagina';
import { AuditLog } from '@/pages/audit/AuditLog';

/** Consola Datalog › Auditoría global (solo agregar), filtrable por entidad. La de una entidad está en su página. */
export function AuditAdmin() {
  return (
    <div className="mx-auto max-w-6xl space-y-6 p-6">
      <EncabezadoPagina titulo="Auditoría" descripcion="Todo lo que pasa en la suite. Nunca se borra ni se edita." />
      <AuditLog />
    </div>
  );
}
